import styled from 'styled-components';

export const Container = styled.div`
  margin-top: ${props => props.theme.spacing.lg};
  padding-top: ${props => props.theme.spacing.sm};
`;

export const Title = styled.h6`
  font-weight: ${props => props.theme.typography.weights.semibold};
  font-size: ${props => props.theme.typography.sizes.xs};
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${props => props.theme.colors.textSecondary};
  flex: 1;
`;

export const Header = styled.div`
  background: ${props => props.theme.colors.grayLight} !important;
  display: flex;
  flex-direction: row;
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.lg};
  margin-bottom: ${props => props.theme.spacing.lg};
  align-items: center;

  & > div {
    background-color: transparent !important;
  }

  /* > div {
    background: #f3f2f7 !important;
    display: flex;
    flex: 1;
    flex-direction: column;

    > div {
      background: #f3f2f7 !important;
      display: flex;
      align-items: center;

      > div {
        background: #f3f2f7 !important;
      }

      > p {
        margin: 0;
        margin-right: 15px;
        margin-left: 31px;
        padding: 0;
      }
    } */
`;

export const DeleteButtonContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-end;
`;

export const BlcokSB = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${props => props.theme.spacing.lg};

  > div {
    width: 48%;
  }

  > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
  }
`;

export const InputArea = styled.input`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  width: 100%;
  min-height: 112px;
  resize: vertical;
  outline: none;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const InputText = styled.input`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const InputSelect = styled.select`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const Div = styled.div`
  display: flex;
  justify-content: space-between;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div {
      margin-right: 16px;
    }
  }
`;

export const CadVtm = styled.button`
  background: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.white};
  border: none;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.xl};
  font-weight: ${props => props.theme.typography.weights.semibold};
`;

export const EditVtm = styled.button`
  background: ${props => props.theme.colors.surface};
  color: ${props => props.theme.colors.textPrimary};
  border: 1px solid ${props => props.theme.colors.borderStrong};
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.xl};
  font-weight: ${props => props.theme.typography.weights.semibold};
`;
